/** Pure function: serialize ManualReading array to CSV string with proper escaping. */

import type { ManualReading } from '@reefapp/shared';

function escapeField(value: string): string {
  // If the value contains a comma, double-quote, newline, or carriage return,
  // wrap in double quotes and escape internal double quotes by doubling them.
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function toCsv(readings: readonly ManualReading[]): string {
  const header = ['Date', 'Parameter', 'Brand', 'Value', 'Unit', 'Kit ID', 'Notes'];
  const rows = readings.map((r) => [
    r.timestamp,
    r.parameter,
    r.brand,
    String(r.value),
    r.unit,
    r.kitId,
    r.notes ?? '',
  ]);

  return [header, ...rows]
    .map((row) => row.map(escapeField).join(','))
    .join('\n');
}